import produce from 'immer';
import { SET_LOGIN, SET_LOGOUT, SET_INVALID_TOKEN } from './patterns';

const INITIAL_STATE = {
  logged: false,
  invalidToken: true,
  profiles: [],
};

export default function auth(state = INITIAL_STATE, action = {}) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_LOGIN: {
        draft.logged = true;
        draft.profiles = action.payload.profiles;
        break;
      }
      case SET_LOGOUT: {
        draft.logged = false;
        draft.profiles = [];
        break;
      }
      case SET_INVALID_TOKEN: {
        draft.invalidToken = action.payload.invalidToken ?? true;
        break;
      }
      default:
    }
  });
}
